import { Component,Injectable } from '@angular/core';
import { Directive, ElementRef, HostListener, Input, Renderer } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from './config.service';

import { appConfig } from '../assets/config/app.config';

@Directive({
  selector: '[appHtmlreaderHeader]'
})
export class HtmlreaderDirectiveHeader {
  headerUrl: any;
  private data: any;
  constructor(el: ElementRef, renderer: Renderer,
    http: Http,
    private configService: ConfigService) {
    this.headerUrl =this.configService.getConfiguration().headerUrl;
    console.log("this.headerUrl" + this.headerUrl);
    http.get(this.headerUrl)//.map((res:Response) => res.toString)
      .subscribe(
      res => {
        console.log(res);
        this.data = res.text();
        renderer.setElementProperty(el.nativeElement, 'innerHTML', this.data);
      });
  }
}
@Directive({
  selector: '[appHtmlreaderFooter]'
})
export class HtmlreaderDirectiveFooter {
  private data: any;
  footerUrl: any;
  constructor(el: ElementRef, renderer: Renderer, http: Http, private configService: ConfigService) {
    this.footerUrl =
      this.configService.getConfiguration().footerUrl;
    console.log("this.footerUrl" + this.footerUrl);
    http.get(this.footerUrl)//.map((res:Response) => res.toString)
      .subscribe(
      res => {
        console.log(res);

        this.data = res.text();
        renderer.setElementProperty(el.nativeElement, 'innerHTML', this.data);
      });
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
	//debugger;
	constructor() {
		document.title = appConfig.pageTile + ' - ' + appConfig.officeTitle;
	}

	public officeTitle: string = appConfig.officeTitle;
	public pageTitle: string = appConfig.pageTile;
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts